<template>
    <div v-if="this.shouldBeVisible">
        <modal
            ref="appPromoModal"
            id="appPromoPopup"
            size="modal-ml"
            :title="$t('appPromoPopup.heading')"
            :centered="true"
            :scrollable="true"
            :show="appPromoModal.show"
            :close="appPromoModal.hide"
            :closeable="appPromoModal.closeable"
            :tighter-close-button="true"
            @modal-opening="onModalOpening"
            @modal-close="onModalClosing"
        >
            <div ref="appPromoModalBody" class="modal-body" :style="bodyStyle">
                <div class="d-flex justify-content-start">
                    <div>
                        <img class="mobile-only" src="/assets/img/svg/app-promo-logo-mobile.svg" alt="App Logo"
                             width="105" height="105" />
                        <img class="desktop-only" src="/assets/img/svg/app-promo-logo.svg" alt="App Logo" width="105"
                             height="105" />
                    </div>
                    <div class="p-left text-mobile">
                        <span v-t="'appPromoPopup.bulletListHeading'" class="text-underline" />
                        <ul>
                            <li class="ml-1 d-flex">
                                <img src="/assets/img/svg/check-icon.svg" alt="-">
                                <span class="ml-2" v-html="$t('appPromoPopup.bulletListPoint1')" />
                            </li>
                            <li class="ml-1 d-flex">
                                <img src="/assets/img/svg/check-icon.svg" alt="-">
                                <span class="ml-2" v-html="$t('appPromoPopup.bulletListPoint2')" />
                            </li>
                            <li class="ml-1 d-flex">
                                <img src="/assets/img/svg/check-icon.svg" alt="-">
                                <span class="ml-2" v-html="$t('appPromoPopup.bulletListPoint3')" />
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="d-flex justify-content-start p-top desktop-only">
                    <div>
                        <span v-html="$t('appPromoPopup.footer')"></span>
                        <br>
                        <div class="d-flex justify-content-end">
                            <div>
                                <img src="/assets/img/svg/app-promo-arrow.svg" alt="Arrow">
                            </div>
                        </div>
                    </div>
                    <div class="ml-4">
                        <img src="/assets/img/svg/app-promo-qr-code.svg" alt="QR Code">
                    </div>
                </div>
                <div class="d-flex justify-content-start mobile-only ml-4 move-up">
                    <div>
                        <div class="">
                            <img src="/assets/img/svg/app-promo-arrow-mobile.svg" alt="Arrow">
                        </div>
                    </div>
                    <div class="ml-2">
                        <a href="https://europamaut.com" target="_blank">
                            <img src="/assets/img/svg/app-promo-download-mobile.svg" alt="App Store" width="130"
                                 height="60">
                        </a>
                    </div>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
export default {
    props: {
        isPaymentConfirmed: {
            type: Boolean,
            required: true,
        },
        showAppPromoPopup: {
            type: Boolean,
            required: true,
        },
    },

    data() {
        return {
            appPromoModal: {
                show: false,
                hide: false,
                closeable: true,
            },
            formStyle: {
                height: '100%',
            },
            bodyStyle: {
                height: '100%',
            },
        };
    },

    computed: {
        /**
         * Determine if the app promo popup should be visible.
         *
         * @returns {Boolean}
         */
        shouldBeVisible() {
            return this.isPaymentConfirmed && this.showAppPromoPopup;
        },
    },

    methods: {
        showModal() {
            this.appPromoModal.show = true;
            this.appPromoModal.hide = false;
            this.appPromoModal.closeable = true;

            return this;
        },

        hideModal() {
            this.appPromoModal.show = false;
            this.appPromoModal.hide = true;
            this.appPromoModal.closeable = true;

            return this;
        },

        onModalOpening() {
            this.$el.ownerDocument.body.classList.add('overflow-hidden');
        },

        onModalClosing() {
            this.$el.ownerDocument.body.classList.remove('overflow-hidden');
            this.onExitSubmit();
            this.hideModal();
        },
    },

    mounted() {
        if (this.shouldBeVisible) {
            this.showModal();
        } else {
            this.hideModal();
        }
    },
};
</script>
<style lang="scss" scoped>
.text-underline {
    text-decoration: underline;
}

li {
    list-style-type: none;
}

ul {
    padding-left: 0;
}

::v-deep .modal-title {
    font-size: 17px;
    margin-top: 5px;
    max-width: 100%;
}

::v-deep .modal-body {
    padding-top: 0;
}

@media (min-width: 992px) {
    ::v-deep .modal-content {
        width: 530px;
    }
    .p-left {
        padding-left: 32px;
    }
    .p-top {
        padding-top: 18px;
    }
    ::v-deep .modal-header {
        padding-bottom: 0;
    }
    .mobile-only {
        display: none !important;
    }
}

@media (max-width: 991px) {
    ::v-deep .modal-content {
        text-align: left;
    }
    .p-left {
        padding-left: 0;
    }
    .desktop-only {
        display: none !important;
    }
    .text-mobile {
        font-size: 12px;
    }
    .move-up {
        margin-top: -15px;
    }
}
</style>
